import * as React from 'react';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import {
    useLivePersonaCard,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';
import { observer } from 'mobx-react-lite';

const styles = require('./GroupFacepilePersona.scss');

export default observer(function GroupFacepilePersona(props: PersonaCardBehaviorProps) {
    const PersonaCardBehavior = useLivePersonaCard(props);
    return (
        <PersonaCardBehavior>
            <div className={styles.groupFacepilePersona} data-is-focusable={true}>
                <PersonaControl
                    name={props.name}
                    emailAddress={props.emailAddress}
                    size={PersonaSize.size24}
                    mailboxType={props.mailBoxType}
                    data-is-focusable={true}
                />
            </div>
        </PersonaCardBehavior>
    );
});
